import { render } from "./Assignments.vue?vue&type=template&id=c6c8801a&scoped=true"
import script from "./Assignments.vue?vue&type=script&lang=js"
export * from "./Assignments.vue?vue&type=script&lang=js"

import "./Assignments.vue?vue&type=style&index=0&id=c6c8801a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c8801a"]])

export default __exports__